import Axios from 'axios';
import tenancyService from './tenancy';

const Api = Axios.create({
  baseURL: tenancyService.getAPICurrentBaseURL()
});

export default Api
